import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Table } from "reactstrap";
import AdminPageShell, { AdminSurface } from "../../../components/Admin/AdminPageShell";
import { getApiUrl, getMediaUrl } from "../../../utils/site";

const DesignList = () => {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDesigns = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(getApiUrl("/api/designs/all"), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDesigns(res.data.data || res.data || []);
      } catch (err) {
        setError("Failed to fetch designs");
      } finally {
        setLoading(false);
      }
    };
    fetchDesigns();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this design?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(getApiUrl(`/api/designs/${id}`), {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDesigns(designs.filter((d) => d.id !== id));
    } catch (err) {
      alert("Failed to delete design");
    }
  };

  const handleTogglePublic = async (id, isPublic) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        getApiUrl(`/api/designs/${id}`),
        { is_public: isPublic ? 1 : 0 },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDesigns(designs.map((d) => (d.id === id ? { ...d, is_public: isPublic ? 1 : 0 } : d)));
    } catch (err) {
      alert("Failed to update gallery visibility");
    }
  };

  return (
    <AdminPageShell
      eyebrow="Creative library"
      title="Design Management"
      description="Curate the design catalogue, control gallery visibility, and keep the design archive polished."
      actions={
        <Link to="/admin/design/add" className="roha-admin-navbar__chip roha-admin-navbar__chip--primary">
          Add new design
        </Link>
      }
    >
      <AdminSurface title="Design archive" subtitle={`${designs.length} design records`}>
        {error ? <p className="roha-admin-muted">{error}</p> : null}
        <div className="roha-admin-table-wrap">
          <Table responsive className="roha-admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Title</th>
                <th>Description</th>
                <th>Image</th>
                <th>Status</th>
                <th>Show in Gallery</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="roha-admin-empty">
                    Loading design archive...
                  </td>
                </tr>
              ) : designs.length ? (
                designs.map((design) => (
                  <tr key={design.id}>
                    <td data-label="ID">{design.id}</td>
                    <td data-label="Title">{design.title}</td>
                    <td data-label="Description">{design.description}</td>
                    <td data-label="Image">
                      {design.image_url ? (
                        <img src={getMediaUrl(design.image_url)} alt="" className="roha-admin-image-thumb" />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td data-label="Status">
                      <span className="roha-admin-pill">{design.status}</span>
                    </td>
                    <td data-label="Show in Gallery">
                      <label className="roha-admin-toggle">
                        <input
                          type="checkbox"
                          checked={!!design.is_public}
                          onChange={(e) => handleTogglePublic(design.id, e.target.checked)}
                        />
                        <span />
                      </label>
                    </td>
                    <td data-label="Actions">
                      <div className="roha-admin-toolbar">
                        <Link to={`/admin/design/edit/${design.id}`} className="roha-admin-navbar__chip">
                          Edit
                        </Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(design.id)}>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="roha-admin-empty">
                    No designs found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </AdminSurface>
    </AdminPageShell>
  );
};

export default DesignList;
